/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React, { useEffect } from "react"
import PropTypes from "prop-types"
import { Helmet } from "react-helmet"

import "./reset.css"
import "./style.css"

const Layout = ({ children, isSponsored = false }) => {
  useEffect(() => {
    const lazyApp = import("firebase/app")
    const lazyAnalytics = import("firebase/analytics")

    // Promise.all([lazyApp, lazyAnalytics]).then(([firebase]) => {
    //   if (typeof window !== 'undefined') firebase.analytics();
    // })
  }, [])

  return (
    <>
      <Helmet bodyAttributes={isSponsored ? { class: "is-sponsored" } : {}}>
        <html lang="nl" />
        <link rel="preconnect" href="http://www.googletagmanager.com" />
        <link rel="preconnect" href="http://fonts.gstatic.com" />
        <link rel="preconnect" href="https://www.google-analytics.com" />
        <link rel="preconnect" href="http://assets.mkbservicedesk.nl" />
        <link rel="preconnect" href="https://www.googleapis.com" />
        <link rel="preconnect" href="https://firestore.googleapis.com" />
        <link rel="preconnect" href="https://www.google.com" />
        <link rel="preconnect" href="https://www.google.nl" />
      </Helmet>
      {children}
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  isSponsored: PropTypes.bool,
}

export default Layout
